module.exports = __webpack_public_path__ + "img/cooperate_jr_01@2x.1ee3e9e8.png";